type CreativeLabelSource = {
  package_name?: string | null;
  creative_name?: string | null;
  detail_1?: string | null;
  detail_2?: string | null;
  [key: string]: unknown;
};

export const getCreativePackageLabel = (creative: CreativeLabelSource = {}) => {
  const labelParts = [
    creative?.package_name || creative?.creative_name,
    creative?.detail_1,
    creative?.detail_2,
  ].filter(Boolean);

  return labelParts.join(": ");
};

export const getCreativePackageChannelLabel = (
  packageChannel: CreativeLabelSource = {}
) => {
  const labelParts = [
    packageChannel?.creative_name,
    packageChannel?.detail_1,
    packageChannel?.detail_2,
  ].filter(Boolean);

  return labelParts.join(": ");
};
